<template>
	<div class="banner-report ">
		<div class="block-title">
			<i class="iconfont icon-bianzu3" ></i>
			<h2>今日流量</h2>
		</div>
		<div class="panel-content">
			<table>
				<tr class="table-title">
					<th class="title" width="8%"></th>
					<th class="data">浏览量(PV)</th>
					<th class="data">访客数(UV)</th>
					<th class="data">IP数</th>
					<th class="data">跳出率</th>
					<th class="data">平均访问时长</th>
					<th class="data">转化次数</th>
				</tr>
				<tr class="today-data">
					<td class="title">今日</td>
					<td class="data">{{reduceStas('todayStasData', 'pv_count')}}</td>
					<td class="data">{{reduceStas('todayStasData', 'visitor_count')}}</td>
					<td class="data">{{reduceStas('todayStasData', 'ip_count')}}</td>
					<td class="data">{{reduceStas('todayStasData', 'bounce_ratio')}}%</td>
					<td class="data">{{reduceStas('todayStasData', 'avg_visit_time')}}</td>
					<td class="data">{{reduceStas('todayStasData', 'trans_count')}}</td>
				</tr>
				<tr class="tomorrow-data">
					<td class="title">昨日</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'pv_count')}}</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'visitor_count')}}</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'ip_count')}}</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'bounce_ratio')}}%</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'avg_visit_time')}}</td>
					<td class="data">{{reduceStas('yesterdayStasData', 'trans_count')}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
export default {
	name: '',
	data() {
		return {

		}
	},
	computed: {
		...mapState('siteStas', ['todayStasData', 'yesterdayStasData']),
		...mapGetters('siteStas', ['reduceStas'])
	},
	methods: {
		...mapActions('siteStas',['getRealtime']),
	}
}
</script>

<style lang="scss" scoped>

   .block-title {
		padding-left: 20px;
		height: 60px;
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		i{
			width:20px;
			font-size: 20px;
			color:$colorD;
		}
		h2 {
			height: 60px;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 2px;
			line-height: 60px;
			color: #373D45;
			padding-left: 10px;
		}
	}
    .banner-report {
		height:300px;
		background:rgba(255,255,255,1);
		border-radius:4px;
        margin-bottom: 20px;
	}
	.panel-content{
		color: #8392A4;
		font-size: 14px;
	}
    .banner-report table {
		width: 100%;
        th,td {
			text-align:center;
			&.title{
				text-align: right;
			}
			&.data{
				width: 14%;
			}
		}
		th{
			padding-bottom: 44px;
		}
		td{
            padding-bottom: 37px;
			&.data{
				font-size: 20px;
				font-family: "DIN Alternate Bold";
				color: #373D45;
			}
		}
    }
    th,td{
        text-align: right;
    }
</style>
